import {
  FilterDataType,
  IUserInfo,
  Unsubscribe,
  USER_TYPE,
} from "@home-health-notify/domain";
import { useContext, useEffect, useState } from "react";
import {
  getDefaultSelectedUserTypes,
  getVisibleUserTypes,
  IOrganizationContext,
  OrganizationContext,
  UserDirectoryContext,
} from "hhn-commons";
import UserDirectoryTabItem from "./UserDirectoryTabItem";

interface ClinicianStaffDirectoryProps {
  chatID: string;
}

const ClinicianStaffDirectory = ({ chatID }: ClinicianStaffDirectoryProps) => {
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);
  const { userDirectory, users } = useContext(UserDirectoryContext);
  const loggedInUserType =
    selectedOrgUser?.getOrganization()?.userProfile?.type ?? USER_TYPE.USER;

  const [filteredUserDirectory, setFilteredUserDirectory] = useState<
    IUserInfo[]
  >([]);
  const [filterTooltipData, setFilterTooltipData] = useState<FilterDataType>(
    {} as FilterDataType,
  );

  const defaultSelectedUserTypes =
    getDefaultSelectedUserTypes(loggedInUserType);

  const filterDirectoryByUserType = (userType: USER_TYPE[]) => {
    const filteredUsers = userDirectory.filterUserDirectory({
      userType,
      userRole: [],
    });
    setFilteredUserDirectory(filteredUsers);
  };

  useEffect(() => {
    const defaultSelectedUserTypes =
      getDefaultSelectedUserTypes(loggedInUserType);
    filterDirectoryByUserType(defaultSelectedUserTypes);
    // `users` triggers re-filter on user-update socket events
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  useEffect(() => {
    const removeListeners: Unsubscribe[] = [];
    if (userDirectory && defaultSelectedUserTypes) {
      const removeSyncUserDirectoryListener =
        userDirectory.registerSyncUserDirectoryListener(() => {
          filterDirectoryByUserType(defaultSelectedUserTypes);
        });
      removeListeners.push(removeSyncUserDirectoryListener);
    }
    return () => {
      removeListeners.forEach(removeListener => removeListener());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelectedUserTypes, userDirectory]);

  const currentUserTypes = getVisibleUserTypes(loggedInUserType);

  return (
    <UserDirectoryTabItem
      chatID={chatID}
      currentUserTypes={currentUserTypes}
      defaultSelectedUserTypes={defaultSelectedUserTypes}
      filterTooltipData={filterTooltipData as FilterDataType}
      setFilterTooltipData={
        setFilterTooltipData as React.Dispatch<
          React.SetStateAction<FilterDataType>
        >
      }
      filteredUserDirectory={filteredUserDirectory}
      setFilteredUserDirectory={setFilteredUserDirectory}
      testId="clinician"
    />
  );
};

export default ClinicianStaffDirectory;
